// extracted by mini-css-extract-plugin
export default {"input":"styles_input__qbX7r","button":"styles_button__-6YTJ","floatLabel":"styles_floatLabel__5T+qS","error":"styles_error__AeatV","errorMessage":"styles_errorMessage__RReyw"};